import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductElement } from '../../../../services/backend.service';

@Component({
    selector: 'app-change-room-hookup',
    templateUrl: './change-room-hookup.component.html',
    styleUrls: ['./change-room-hookup.component.scss'],
    standalone: false,
})
export class ChangeRoomHookupComponent {
    data = inject<ProductElement>(MAT_DIALOG_DATA);

    dialogValue?: boolean;

    constructor() {
        const data = this.data;

        this.dialogValue = data.config.room_hookup;
    }
}
